import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'optimizationSettings',
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  emptyMessage: "You don't have optimization settings for this job.",
  fields: [
    {
      attributeName: 'geometry',
      label: 'Geometry',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      canEdit: false,
      canCreate: false,
      helpText: 'Geometry transformations to apply.',
      width: '12rem',
    },
    {
      attributeName: 'opBitrates',
      label: 'Bitrate',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      default: '',
      canEdit: false,
      canCreate: false,
      helpText: ' Video bitrates to use in output (kbps).',
    },
    {
      attributeName: 'faceDimension',
      label: 'Face Dimension',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      default: '',
      canEdit: false,
      canCreate: false,
      helpText: 'For renditions using the cubemap transformations, the face dimension size to be applied in each profile (pixels).',
    },
    {
      attributeName: 'opOffcenterZ',
      label: 'Off Center',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      default: '',
      canEdit: false,
      canCreate: false,
      helpText: 'For renditions using the transform filter, the offcenter to be applited in the x axis (values between 0.5 and -0.5).',
    },
    {
      attributeName: 'opStereoModeOut',
      label: 'Stereo Mode Out',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canEdit: false,
      canCreate: false,
      helpText: 'The stereo mode of each rendition.',
    },
    {
      attributeName: 'renditionRes',
      label: 'Rendition Res',
      type: FormInputTypes.TEXT_INPUT.STRING,
      default: '',
      canEdit: false,
      canCreate: false,
      helpText: 'The desired output resolution in each rendition leave empty, or use 0 in that list element if no resizing is desired (e.g. input resolution is to be preserved, or the output from transform filter is ok to use) use FFMpeg\'s format for resolution when using this parameter (e.g. "1920:1080,1280:720" for two resolutions, one 1080p and another one 720p), negative values are not supported.',
    },
  ],
};
